import React, { useCallback, useMemo } from 'react';
import { useTextField } from '../../hooks/use-text-field';
import { useTranslation } from 'react-i18next';
import { Form, Select as AntdSelect, Tooltip } from 'antd';
import { sortByAlphabet, exclude } from './utils';
import styles from './styles.module.less';

const STYLE = { width: '100%' };
const { Option } = AntdSelect;


export function Select({
  name,
  options,
  loading,
  label,
  tooltip,
  showSearch,
  namespace,
  needSort = true,
  defaultValue,
  excluded = [],
  mode,
  allowClear,
  placeholder,
  disabled,
}) {
  const { t, i18n } = useTranslation();

  const [value, { hasError, handleOnChange, handleBlur, error }] =
    useTextField(name);

  const handleFilter = useCallback((input, option) => (
    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
  ), [])

  const transformedOptions = useMemo(() => {
    let transformed = options;

    // if excluded option is set will filter array
    if (excluded.length > 0) {
      transformed = exclude(
        options,
        excluded,
      )

      if (value) {
        transformed = transformed.concat(value)
      }
    }

    transformed = transformed.map(option => ({
      value: option,
      title: namespace ? t(`${namespace}.${option}`) : t(option),
    }))

    if (needSort) {
      return transformed.sort(sortByAlphabet)
    }

    return transformed
  }, [
    needSort,
    options,
    t,
    namespace,
    excluded,
    value,
  ]);

  const component = (
    <AntdSelect
      mode={mode}
      disabled={disabled}
      loading={loading}
      onBlur={handleBlur}
      value={value}
      showSearch={showSearch}
      filterOption={showSearch ? handleFilter : undefined}
      onChange={handleOnChange}
      style={STYLE}
      defaultValue={defaultValue}
      allowClear={allowClear}
      placeholder={placeholder}
    >
      {transformedOptions?.map((option) => (
        <Option
          key={`${option.value}-${i18n.language}`}
          value={option.value}
        >
          {option.title}
        </Option>
      ))}
    </AntdSelect>
  )

  return (
    <Form.Item
      className={`${styles.root}`}
      // label={t(label)}
      hasFeedback={hasError}
      help={hasError ? t(error) : false}
      validateStatus={hasError ? 'error' : 'success'}
    >
      {tooltip
        ? (
          <Tooltip
            placement="bottomRight"
            title={t(tooltip)}
            trigger="click"
          >
            {component}
          </Tooltip>
        )
        : (
          component
        )
      }
    </Form.Item>
  )
}